// is this semi-truthy-semi-enum evil? I'm not sure
const machineBuildPermission = {
	SUCCESS: true,
	NOPOWER: 'nopower',
	NOFAVOURS:'nofavours'
};
export default machineBuildPermission;